import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import { all } from 'rsvp';
import Transition from '@ember/routing/-private/transition';
import NewsletterModel from 'cio/models/newsletter';
import FiltersService from 'cio/services/filters';
import DS from 'ember-data';

export default class IndexRoute extends Route {
  @service filters!: FiltersService;
  @service store!: DS.Store;

  model() {
    return this.modelFor('broadcasts.newsletter');
  }

  afterModel(model: NewsletterModel, transition: Transition) {
    super.afterModel(model, transition);

    return all([model.findRecipients(), this.store.findAll('short-segment'), this.filters.process.perform()]);
  }
}
